import type { TFunction } from 'i18next'

/**
 * Libellé d'un rôle à l'écran : « Apprenant », pas le nom technique `User`.
 * Un rôle sans traduction garde son nom plutôt qu'une clé brute.
 */
export function roleLabel(t: TFunction, roleName: string): string {
  return t(`role.${roleName}`, { defaultValue: roleName })
}
